import {Box, Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    ActionHistoryButton,
    CustomerInformationPanel,
    ExitButton,
    PrintButton,
    StoreInformationPanel,
    WorkOrderDatesPanel,
    WorkOrderFilesButton,
    WorkOrderInformationPanel,
    WorkOrderNotes,
    WorkOrderPage,
    WorkOrderProgress
} from '../../../features/cfi/work-order';
import '../../../css/order.scss';

export default function WorkOrderInfoPage() {

	return (

		<WorkOrderPage>

			<WorkOrderProgress />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<PrintButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ActionHistoryButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<WorkOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>
			<Box>
				<Item ratio={1}>
					<WorkOrderInformationPanel />
				</Item>
				<Item ratio={1}>
					<WorkOrderDatesPanel />
				</Item>
			</Box>
			<Box>
				<Item ratio={1}>
					<CustomerInformationPanel />
				</Item>
				<Item ratio={1}>
					<StoreInformationPanel />
				</Item>
			</Box>

			<WorkOrderNotes />

		</WorkOrderPage>
	)
}
